export type MarketplaceKey =
  | 'Ajio'
  | 'Amazon'
  | 'Flipkart'
  | 'Littlebox'
  | 'Meesho'
  | 'Myntra'
  | 'Myntra FWD'
  | 'Newme'
  | 'Nykaa'
  | 'Outcast'
  | 'Savana'
  | 'Shopsy'
  | 'Tata CLiQ'
  | 'Urbanic'
  | 'Westside'
  | 'Zara';

export const MAKRKETPLACE_IMAGE_MAP: Record<MarketplaceKey, string> = {
  Ajio: '/images/brands/Ajio.png',
  Amazon: '/images/brands/Amazon.png',
  Flipkart: '/images/brands/Flipkart.png',
  Littlebox: '/images/brands/Littlebox.png',
  Meesho: '/images/brands/Meesho.png',
  Myntra: '/images/brands/Myntra.png',
  'Myntra FWD': '/images/brands/Myntra.png',
  Newme: '/images/brands/Newme.png',
  Nykaa: '/images/brands/Nyka.png',
  Outcast: '/images/brands/Outcast.png',
  Savana: '/images/brands/Savana.png',
  Shopsy: '/images/brands/Shopsy.png',
  'Tata CLiQ': '/images/brands/TataCliq.png',
  Urbanic: '/images/brands/Urbanic.png',
  Westside: '/images/brands/Westside.png',
  Zara: '/images/brands/Zara.png',
} as const;
